{
  "title": "Shield",
  "source": "Player's Handbook",
  "levelAndSchool": "1st-level abjuration",
  "level": 1,
  "castingTime": "1 reaction, which you take when you are hit by an attack or targeted by the magic missile spell",
  "range": "Self",
  "components": "V, S",
  "duration": "1 round",
  "description": [
    "An invisible barrier of magical force appears and protects you. Until the start of your next turn, you have a +5 bonus to AC, including against the triggering attack, and you take no damage from magic missile."
  ],
  "spellLists": ["eldritch-knight", "sorcerer", "wizard"]
}
